import {
  Component,
  inject,
} from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import {MatButton} from '@angular/material/button';

@Component({
  selector: 'app-remark-bottom-sheet',
  imports: [MatButton],
  templateUrl: './remark-bottom-sheet.component.html',
  styleUrl: './remark-bottom-sheet.component.scss',
})
export class RemarkBottomSheetComponent {

  private bottomSheetRef = inject(MatBottomSheetRef<RemarkBottomSheetComponent>);

  public data = inject<{title: string, contentText: string, closeLabel: string}>(MAT_BOTTOM_SHEET_DATA);

  public title: string = this.data.title;

  public contentText: string = this.data.contentText;

  public closeLabel: string = this.data.closeLabel;

  closeBottomSheet(): void {
    this.bottomSheetRef.dismiss();
  }

}
